import React from 'react'
import '../index.scss'
import { getWeightUnit, DIMENSION_UNIT } from '../../../../constants'
import { useTranslation } from 'react-i18next'

const LooseInfoDisplay = ({
    weightUnit,
    dimensionUnit,
    looseInfocolumns,
    looseInfoDetails,
    isCrates
}) => {
    //for multilingual
    const [t] = useTranslation(['labels'])
    return (
        <div className='looseInfo-card-wrapper'>
            {looseInfoDetails && looseInfoDetails.length > 0 ? (
                looseInfoDetails.map((looseInfo, looseInfoIndex) => (
                    <div className="looseInfo-card" key={looseInfoIndex}>
                        <div className="looseInfo-row">
                            <div className="looseInfo-col">
                                <div className="looseInfo-heading">{t(looseInfocolumns[0])}</div>
                                <div className="looseInfo-data">{looseInfo.numberOfPieces}</div>
                            </div>
							<div className="looseInfo-col">
								<div className="looseInfo-heading">
									{`${t(looseInfocolumns[1])}x${t(looseInfocolumns[2])}x${t(looseInfocolumns[3])}`}
								</div>
								<div className="looseInfo-data">
									{/* {`${looseInfo.length}×${looseInfo.width}×${looseInfo.height}`} */}
                                    {`${looseInfo.lengthPerPiece}×${looseInfo.widthPerPiece}×${looseInfo.heightPerpiece}`}

								</div>
							</div>
                            {/* <div className="looseInfo-col">
                                <div className="looseInfo-heading">{t(looseInfocolumns[4])}</div>
                                <div className="looseInfo-data">{looseInfo.weight == 0 ? '-' : looseInfo.weight}</div>
                            </div> */}
                            <div className="looseInfo-col">
                                <div className="looseInfo-heading">
                                    {isCrates === 'LIVE DOGS' || isCrates === 'LIVE CATS' ? '' : t(looseInfocolumns[5])}
                                </div>
                                <div className="looseInfo-data">
                                    {isCrates === 'LIVE DOGS' || isCrates === 'LIVE CATS' ? '' : t('COMMON.TOTAL')}
                                </div>
                            </div>
                            <div className="looseInfo-col">
                                <div className="looseInfo-heading">
                                    {isCrates === 'LIVE DOGS' || isCrates === 'LIVE CATS' ? '' : t(looseInfocolumns[6])}
                                </div>
								<div className="looseInfo-data" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
									{isCrates === 'LIVE DOGS' || isCrates === 'LIVE CATS'
										? ''
										: [
											(looseInfo.stackable === 'Y' || !looseInfo.stackable) ? t('COMMON.STACKABLE') : t('COMMON.NON_STACKABLE'),
											looseInfo.tiltable === 'Y' ? t('COMMON.TILTABLE') : t('COMMON.NON_TILTABLE')
										].filter(Boolean).join(', ')
									}
								</div>
                            </div>
                        </div>
                    </div>
                ))
            ) : (
                <div className="looseInfo-no-data">{t('NO_DATA')}</div>
            )}
        </div>
    )
}

export default LooseInfoDisplay